import React, {useEffect, useState} from 'react';
import {Card} from "react-bootstrap";
import {InfoCircleFill} from "react-bootstrap-icons";

/**
 * A nice error message component with auto-dismiss functionality
 * @param {string} title - The error title/name
 * @param {string} message - The detailed error message
 * @param {string} colorClass - The color of the icon
 * @param {number} autoDismiss - Time in milliseconds to auto-dismiss (0 = no auto-dismiss)
 * @param {Function} onDismiss - Callback function when error is dismissed
 */
export default function MessageBox({title, message, colorClass, autoDismiss = 0, onDismiss}) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        setIsVisible(true);

        if (autoDismiss > 0) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                if (onDismiss) {
                    onDismiss();
                }
            }, autoDismiss);

            return () => clearTimeout(timer);
        }
    }, [title, message, colorClass, autoDismiss, onDismiss]);

    if (!isVisible || !title) {
        return null;
    }

    return (
        <Card style={{margin: '20px 0'}}>
            <Card.Body>
                <Card.Title className='canopia2'>
                    <div style={{display: "flex", flexWrap: "nowrap"}}>
                        <div style={{flexBasis: '30px', marginTop: '.3rem'}}>
                            <InfoCircleFill className={colorClass} size={'1.4em'}/>
                        </div>
                        <div className={colorClass}>
                            <h4>{title}</h4>
                        </div>
                    </div>
                </Card.Title>
                {message && <Card.Text>
                    {message}
                </Card.Text>}
            </Card.Body>
        </Card>
    );
}
